import { Component, OnInit, Inject, Optional, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NavigationService } from 'services/navigation.service';
import { AlertService } from 'services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'services/authentication.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-otpverification',
  templateUrl: './otpverification.component.html',
  styleUrls: ['./otpverification.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OtpVerificationComponent implements OnInit {

  recaptchaToken: String = null;
  otp: any;
  showTimer: boolean = false;
  otpTimer: number;
  otpInterval: NodeJS.Timeout;
  showResendButton: boolean = false;
  timerDisplay: string;
  IsRecaptchaRequired: boolean = false;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px',
      'color': '#6f6f6f'
    }
  };
  siteKey = environment.recaptcha.siteKey
  @ViewChild('ngOtpInput', { static: false })
  ngOtpInput: any;
  failedcount: number = 0
  captchaRef!: RecaptchaComponent;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private authService: AuthenticationService,
    private alertService: AlertService,
    @Optional() public dialogRef: MatDialogRef<OtpVerificationComponent>) {
    if (this.data) {
      console.log(this.data);

    }
  }


  ngOnInit() {
    this.startOtpTimer()
    if (window.innerWidth <= 420) {
      this.config = {
        ...this.config,
        inputStyles: {
          'width': '35px',
          'height': '35px',
          'color': '#6f6f6f'
        }
      };
    }
  }



  onOtpChange(otp) {
    this.otp = otp;
    if (this.otp.length == 6) {
      this.verifyOTP();
    }
  }



  verifyOTP() {
    var payloaddata: any = {};
    payloaddata.validationOtpId = this.data.ValidateOtpId;
    payloaddata.otpPageType = 2;
    payloaddata.otp = this.otp;
    payloaddata.userRegister = this.data.registerDetails;


    this.authService.validateOtp(payloaddata).subscribe((res) => {
      if (res.isSuccess != true) {
        this.alertService.error(res.htmlFormattedFailures)
        this.otp = null
        this.ngOtpInput.setValue('');
        setTimeout(() => {
          this.ngOtpInput.focusTo(0);
        }, 50);
        this.failedcount += 1
        if (this.failedcount > 3) {
          this.dialogRef.close();
        }
      }
      else if (res.isSuccess == true) {
        this.alertService.success(res.value)
        this.dialogRef.close(true)
      }
    });
  }




  startOtpTimer() {
    this.showTimer = true;
    this.otpTimer = 120;
    this.updateTimerDisplay();

    this.otpInterval = setInterval(() => {
      this.otpTimer--;
      this.updateTimerDisplay();

      if (this.otpTimer <= 0) {
        clearInterval(this.otpInterval);
        this.showResendButton = true;
        this.ngOtpInput.setValue('');
        this.ngOtpInput.focusTo(0);
        this.otp = null

        setTimeout(() => {
          const firstOtpBox = document.querySelector('.otp-boxes input');
          if (firstOtpBox) {
            (firstOtpBox as HTMLInputElement).focus(); // Force native focus
          }
          this.showCaptchaAfterTimeout();

        }, 10);
        this.recaptchaToken = null;
      }
    }, 1000);
  }

  updateTimerDisplay() {
    const minutes = Math.floor(this.otpTimer / 60);
    const seconds = this.otpTimer % 60;
    this.timerDisplay = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  sendOtp() {
    if (this.recaptchaToken == null) {
      this.IsRecaptchaRequired = true;
    }
    else {
      // var formValues = this.loginForm.getRawValue();
      this.data.ValidateOtpId = 0
      var payloaddata: any = {
        captchaToken: this.recaptchaToken,
        recipient: this.data.registerDetails.mobileNumber,
        otpPageType: 2,
         notificationPreferenceType:2
      };
      this.authService.verifyCaptchaAndGenerateOTP(payloaddata).subscribe((res) => {
        if (res.isSuccess == true) {
          this.data.ValidateOtpId = res.value.id;
          this.showTimer = true;
          this.startOtpTimer();
          this.alertService.success("OTP resent successfully")

        }
        else if (res.isSuccess != true)
          this.alertService.error(res.errorMessage)
      });
    }
  }


  onCancel() {
    this.dialogRef.close(false);
  }

  showCaptchaAfterTimeout() {
    console.log(this.captchaRef);

    // Wait until DOM is rendered
    setTimeout(() => {
      this.captchaRef.reset();
    });
  }
  onCaptchaResolved(token: string) {
    this.recaptchaToken = token;
    console.log(this.recaptchaToken);

  }
}
